export const UserActionTypes = {
  SET_CURRENT_USER: 'SET_CURRENT_USER',
  USER_CAME_FROM_CHECKOUT: 'USER_CAME_FROM_CHECKOUT'
}